import { Vectors } from "@project-rouge/rg-three";
import { MathUtils, Vector3 } from "three";
import { defaultAggProps } from "./index233.js";
function getNorthWeightMod({ avoidNorthRange, avoidNorthFactor = defaultAggProps.avoidNorthFactor }) {
  if (!avoidNorthRange)
    avoidNorthRange = defaultAggProps.avoidNorthRange;
  const dotRange = Math.cos(0.5 * avoidNorthRange * MathUtils.DEG2RAD);
  return (lines) => lines.map((line) => getLineWeight(line, dotRange, avoidNorthFactor));
}
function getLineWeight(line, dotRange, avoidNorthFactor) {
  if (isWithinAngle(line, dotRange))
    return 1;
  return 1 - avoidNorthFactor;
}
const _dir = new Vector3();
function isWithinAngle(l, dotRange) {
  const north = Vectors.Back;
  _dir.copy(l.end).sub(l.start);
  const dot = _dir.dot(north);
  return Math.abs(dot) > dotRange;
}
export {
  getNorthWeightMod
};
//# sourceMappingURL=index192.js.map
